import request from "@/utils/request";

//查询会员功能icon图列表
export function querySysIconInfoList(params) {
  return request({
    url: "/api/system/sysIconInfo/querySysIconInfoList",
    method: "post",
    data: params
  });
}

export function querySysVipSettingList(params) {
  return request({
    url: "/api/system/sysVipSetting/querySysVipSettingList",
    method: "post",
    data: params
  });
}

//vip 充值
export function vipPayBalance(params) {
  return request({
    url: "/api/system/vipPayServiceFee/vipPayBalance",
    method: "post",
    data: params
  });
}

//vip 余额充值
export function vipBuyBalance(params) {
  return request({
    url: "/api/system/vipPayServiceFee/vipBuyBalance",
    method: "post",
    data: params
  });
}



//vip 充值
export function queryVipPayBalance(params) {
  return request({
    url: "/api/system/vipPayServiceFee/queryVipPayBalance",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/vip/index.js